/**
 * 缩略图区域组件
 * @author wangyichen
 * @since 2018/09/16
 */
import './thumbnail.less';
import CONFIG from 'constants/config.json5';
import React, { Component } from 'react';
import { isString } from '@fe/common/lib/check-types';
import PropTypes from 'prop-types';
const readyType = '__POST_MESSAGER_READY__';
const THUMBNAIL_WIDTH = 168;
const THUMBNAIL_HEIGHT = 264;
class Thumbnail extends Component {
  // screenshot iframe对象的h5Messager
  shotMessager;
  static propTypes = {
    // 当前页码
    currentPage: PropTypes.number,
    // 页面总数
    pageCount: PropTypes.number,
    // 设置目标页码
    setTargetPage: PropTypes.func,
    // 基础信息
    baseInfo: PropTypes.object,
    // 设置是否循环翻页
    setPageLoop: PropTypes.func,
    // 设置页数
    setPageCount: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.shotMessager = null;
    this.screenShotData = [];
    this.state = {
      arrScreenShot: [],
      pageCount: this.props.pageCount,
      visiableCount: 1,
      currentPage: 0,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPage !== this.props.currentPage) {
      this.setState({
        currentPage: nextProps.currentPage - 1,
      });
    }
  }
  componentDidMount() {
    this.listenShotIframe();
    this.listenMouseWheel();
    this.reSendFirst();
    const { appUrl } = this.props.baseInfo;
    const dealUrl = appUrl
      ? appUrl.replace(/(\/m2\/|\/m\/|\/mspa\/)/, '/m2/screenshot/')
      : '';
    this.screenShotIframe.src =
      // 'http://localhost.rabbitpre.com:12000/m2/screenshot/qyFZnb6A?mobile=1&capture=1';
      `${dealUrl.replace(/^(https|http):\/\//, '//')}?mobile=1&capture=1`;
  }
  componentWillUnmount() {
    this.shotMessager && this.shotMessager.close();
  }
  // 监听重发第一页
  reSendFirst = () => {
    setTimeout(() => {
      if (!this.state.arrScreenShot[0] && this.screenShotIframe) {
        const targetWindow = this.screenShotIframe.contentWindow;
        targetWindow.postMessage(
          JSON.stringify({ type: '__PAGE_SCREEN_SHOT__', page: 0 }),
          '*'
        );
      }
    }, 3000);
  };
  // 监听截图 iframe
  listenShotIframe = () => {
    window.addEventListener('message', evt => {
      if (!evt.data) return;
      const data = isString(evt.data) ? JSON.parse(evt.data) : evt.data;
      switch (data.type) {
        case 'RENDERER_PLUGIN_SCREENSHOT_READY': {
          this.sendShotAction(data);
          break;
        }
        case '__PAGE_SCREEN_SHOT_RESULT__': {
          if (data.data && data.data.base64) {
            this.dealShotData(data.data);
          }
          break;
        }
      }
    });
  };
  // 先发准备消息，再发送截图的动作
  sendShotAction(data) {
    if (!this.screenShotIframe || !this.screenShotIframe.contentWindow) return;
    const targetWindow = this.screenShotIframe.contentWindow;
    targetWindow.postMessage(JSON.stringify({ type: readyType }), '*');
    const { pageCount, pageLoop, visiableCount } = data;
    this.props.setPageCount(pageCount);
    this.props.setPageLoop(pageLoop);
    this.setState({ visiableCount, pageCount }, () => {
      // 间隔600ms*i截取图片
      for (let i = 0; i < visiableCount; i++) {
        // setTimeout(
        setTimeout(
          () =>
            targetWindow.postMessage(
              JSON.stringify({ type: '__PAGE_SCREEN_SHOT__', page: i }),
              '*'
            ),
          600 * i
        );
      }
    });
  }
  // 处理收到的截图数据
  dealShotData(data) {
    let { base64, page, pageIndex } = data;
    pageIndex = parseInt(pageIndex);
    let img = new Image();
    img.onload = () => {
      // 缩放比率，解决因浏览器缩放造成的
      const ratio = THUMBNAIL_WIDTH / img.width;
      // 将总高度减小5个px，避免因计算误差出现空页的情况
      const dealHeight = img.height * ratio - 5;
      if (this.state.pageCount === 1 && dealHeight > THUMBNAIL_HEIGHT) {
        // 一页作品
        for (let i = 0; i < dealHeight / THUMBNAIL_HEIGHT - 1; i++) {
          this.screenShotData.push({
            isOnePage: true,
            base64,
            pageIndex,
            position: -THUMBNAIL_HEIGHT * i,
          });
        }
        this.screenShotData.push({
          isOnePage: true,
          base64,
          pageIndex,
          position: THUMBNAIL_HEIGHT - dealHeight,
        });
        this.setState({ visiableCount: this.screenShotData.length });
      } else {
        // 翻页作品or翻页+一页作品
        // 如果是翻页+一页的作品，一页的作品可能回来的晚，所以要按顺序插入
        this.screenShotData[page] = { base64, pageIndex, position: 0 };
      }
      this.setState({ arrScreenShot: this.screenShotData });
    };
    // 加载图片
    img.src = base64;
  }

  /**
   * 获取缩略图dom节点
   * @param {*} arrScreenShot
   * @param {*} visiableCount
   * @param {*} currentPage
   */
  getThumnbnailList(arrScreenShot, visiableCount, currentPage) {
    return Array.from({ length: visiableCount }).map((v, i) => (
      <li
        onClick={e => {
          e.stopPropagation();
          this.props.setTargetPage(arrScreenShot[i].pageIndex);
          this.setState({
            currentPage: i,
          });
        }}
        key={i}
        className={
          currentPage ==
            (arrScreenShot[i] ? arrScreenShot[i].pageIndex : undefined) &&
          !arrScreenShot[i].isOnePage
            ? 'thumbnail-item active'
            : 'thumbnail-item'
        }
        style={this.getLiStyle(arrScreenShot, i)}>
        <span className="loading">{arrScreenShot[i] ? '' : '加载中...'}</span>
      </li>
    ));
  }
  /**
   * 获取缩略图li项的样式
   * @param {*} arrScreenShot
   * @param {*} i
   */
  getLiStyle(arrScreenShot, i) {
    return {
      backgroundImage: `url(${
        arrScreenShot[i] ? arrScreenShot[i].base64 : ''
      })`,
      backgroundPositionY: `${
        arrScreenShot[i] ? arrScreenShot[i].position : 0
      }px`,
      backgroundRepeat: 'no-repeat',
    };
  }
  // 监听缩略图模块的横向滚动
  listenMouseWheel = () => {
    const domThumbnail = document.querySelector('#thumbnail');
    // 鼠标滚轮回调
    const mouseWheel = function(e) {
      e.stopPropagation();
      // 不兼容firefox
      if (e.wheelDelta > 0) {
        // 向下滚
        domThumbnail.scrollLeft = domThumbnail.scrollLeft - 42;
      } else {
        // 向上滑
        domThumbnail.scrollLeft = domThumbnail.scrollLeft + 42;
      }
      e.preventDefault();
    };

    domThumbnail.addEventListener('mousewheel', mouseWheel, false);
  };

  render() {
    const { arrScreenShot, visiableCount, currentPage } = this.state;
    return (
      <div className="iframe-wrapper">
        <iframe
          className="shot-iframe"
          key="screenshot"
          frameBorder={0}
          ref={el => (this.screenShotIframe = el)}
          width={CONFIG.PAGE_WIDTH + 2}
          height={CONFIG.PAGE_HEIGHT + 2}
        />
        <ul className="thumbnail" id="thumbnail">
          {this.getThumnbnailList(arrScreenShot, visiableCount, currentPage)}
        </ul>
      </div>
    );
  }
}

export default Thumbnail;
